import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDriverEventsList } from "./autogen/AutogenLayoutDriverEventsList";
import { CommonTooltips } from "@mcleod/common";
import { CityUtil, UrlUtil } from "@mcleod/core";

export class DriverEventsList extends AutogenLayoutDriverEventsList {
    override onLoad() {
        this.addLayoutLoadListener(() => {
            this.textboxEquipmentId.focus();
        });

        const urlParams = UrlUtil.getPropsFromUrl(window.location.href);
        if(urlParams != null){
            const status = urlParams["status"];
            this.mainDataSource.search({auto_search_type: status});
        }

    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEquipmentId. */
    textboxEquipmentIdBeforeLookupModelSearch(event) {
        event.filter.only_active = true;
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEventCode. */
    textboxEventCodeBeforeLookupModelSearch(event) {
        event.filter.equip_type = 'D';
    }

    /** This is an event handler for the onRowDisplay event of tableDriverEvents. */
    tableDriverEventsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.data != null) {
            const modelRow = tableRow.data;

            const labelGridCityStateZip: Label = tableRow.findComponentById("labelGridCityStateZip") as Label;
            labelGridCityStateZip.text = CityUtil.formatCityStateZip(modelRow.get("city"), modelRow.get("state"), modelRow.get("zip_code"));

            const labelGridDriverName: Label = tableRow.findComponentById("labelGridDriverName") as Label;
            CommonTooltips.setTooltipContentLayout(
                labelGridDriverName, null, "lme/dispatch/asset/DriverQuickInfo", null,
                {"id":modelRow.get("equipment_id")}
            );

            const labelGridDriverManager: Label = tableRow.findComponentById("labelGridDriverManager") as Label;
            CommonTooltips.setTooltipContentLayout(
                labelGridDriverManager, null, "common/UserQuickInfo", null,
                {"id":modelRow.get("driver_mgr_id")}
            );

            const labelGridEvent: Label = tableRow.findComponentById("labelGridEvent") as Label;
            CommonTooltips.setTooltipContentLayout(
                labelGridEvent, null, "lme/dispatch/asset/DriverEquipStatusCodeQuickInfo", null,
                {"code":modelRow.get("event_code")}
            );

            const labelGridLocationName: Label = tableRow.findComponentById("labelGridLocationName") as Label;
            CommonTooltips.setTooltipContentLayout(
                labelGridLocationName, null, "lme/dispatch/LocationQuickInfo", null,
                {"id":modelRow.get("location_id")}
            );

        }
    }
}
